import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

export const agendaService = {
  async getAgenda({ entityId, view = 'day', date, status, search } = {}) {
    try {
      let url = `${ENDPOINTS.V3_AGENDA}?entityId=${entityId}`;
      if (view) url += `&view=${view}`;
      if (date) url += `&date=${date}`;
      if (status) url += `&status=${status}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      const response = await api.get(url);
      const data = response.data?.response;
      const schedules = Array.isArray(data) ? data : (data?.schedules || []);
      return { success: true, schedules, total: data?.total || schedules.length };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar agenda' };
    }
  },

  async createAgenda(payload) {
    try {
      const response = await api.post(ENDPOINTS.V3_AGENDA, payload);
      return { success: true, schedule: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao criar agendamento' };
    }
  },

  async updateAgenda(id, payload) {
    try {
      const response = await api.put(`${ENDPOINTS.V3_AGENDA}/${id}`, payload);
      return { success: true, schedule: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao atualizar agendamento' };
    }
  },

  async deleteAgenda(id, reason) {
    try {
      await api.delete(`${ENDPOINTS.V3_AGENDA}/${id}`, { data: reason ? { reason } : undefined });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao excluir agendamento' };
    }
  },

  async removeAgenda(id) {
    try {
      await api.delete(`${ENDPOINTS.V3_AGENDA}/${id}/remove`);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao remover agendamento' };
    }
  },

  async startAppointment(id) {
    try {
      const response = await api.post(`${ENDPOINTS.V3_AGENDA}/${id}/start`);
      return { success: true, data: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao iniciar atendimento' };
    }
  },

  async blockSlot(payload) {
    try {
      const response = await api.post(ENDPOINTS.V3_AGENDA_BLOCK, payload);
      return { success: true, data: response.data?.response || null };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao bloquear horário' };
    }
  },

  async getAvailableSlots({ entityId, date, durationMinutes } = {}) {
    try {
      let url = `${ENDPOINTS.V3_AGENDA_AVAILABLE_SLOTS}?entityId=${entityId}&date=${date}`;
      if (durationMinutes) url += `&durationMinutes=${durationMinutes}`;
      const response = await api.get(url);
      return { success: true, slots: response.data?.response || [] };
    } catch (error) {
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar horários disponíveis' };
    }
  },
};
